<template>
  <div class="container">
    <div class="img-list">
      <img v-for="(img, index) in imgList" :key="index" class="img-item" :src="img">
    </div>
    <div class="service-tips">付费即表示同意<span class="service-txt" @click="toService">《拉勾网增值服务协议》</span></div>
    <div v-if="showModal" class="modal-container">
      <div class="modal">
        <div class="modal-close" @click="showModal = false"></div>
        <div class="modal-header">
          <img class="modal-header-img" src="../assets/img/h5/succeed_icon.png">
          <span class="modal-header-txt">报名成功</span>
        </div>
        <div class="modal-desc">添加小助手，预约专家服务</div>
        <img class="qrCode" :src="isApp ? qrCodeUrl : qrCodeUserUrl" />
        <div class="modal-btn" @click="openWeapp">{{ isApp ? '立即添加' : '长按图片识别' }}</div>
      </div>
    </div>
    <div class="footer-wrap">
      <div v-if="!hasBuy" class="footer">
        <div class="footer-left">
          <div class="price">
            <span class="symbol">￥</span>1<span class="cut">原价￥699</span>
          </div>
          <div class="price-tips">为你的求职加速助力</div>
        </div>
        <div class="footer-right"  @click="handleClick('支付按钮')">
          <span>内推名额有限，立即抢占</span>
          <img class="footer-img" src="../assets/img/h5/footer_icon.png" />
          <div class="right-tips">限时特惠</div>
          <img
            class="img-btns"
            src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
          />
        </div>
      </div>
      <div v-else class="footer-oth">
        <div class="footer-oth-left" @click="handleShowModal">获取专属内推服务</div>
        <div class="footer-oth-right" @click="handleClick('¥699 购买')">¥699 购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { purchasedCourse } from "../../../service/api";
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
import * as Cookies from 'js-cookie';
import LgPay from 'lg-pay';
const lgPay = new LgPay();
export default {
  name: "InterviewCardH5",
  data() {
    return {
      imgList: [
        "https://s20.lgstatic.com/growth/activity/20220210/1644460132463.png",
        "https://s21.lgstatic.com/growth/activity/20220210/1644460163323.png",
        "https://s21.lgstatic.com/growth/activity/20220210/1644460183282.png",
        "https://s21.lgstatic.com/growth/activity/20220210/1644460199235.png"
      ],
      showModal: false,
      hasBuy: false,
      isAndroid: navigator.userAgent.indexOf('Android') !== -1,
      qrCodeUserUrl: 'https://s20.lgstatic.com/growth/activity/20211215/1639548810152.png?x-oss-process=style/80',
      qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20211215/1639560244765.png?x-oss-process=style/80',
      page_id:'m1ti9'
    };
  },
  created() {
    // App支付成功显示弹窗
    window.lgBridge && window.lgBridge.response('nativePurchaseCallback', function (data, response, ext) {
      window.location.href = `${location.origin}${location.pathname}?hasBuy=1`
    });
    if (location.href.includes('hasBuy') && location.hash != '#refreshed') {
      location.hash = 'refreshed'
      this.showModal = true;
    }
  },
  mounted() {
    this.eduPlatTrack('WebView', {
        page_id: this.page_id
    });
    if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token') || this.isApp) {
      this.purchasedCourse();
    }
  },
  methods: {
    toService(){
      this.eduPlatTrack('WebButtonClick', {
            'page_id': this.page_id,
            'button_name': '增值服务协议按钮'
      });
      setTimeout(() => {
        this.goHref("https://activity.lagou.com/app/business/service-agreement.html")
      }, 200);
    },
    purchasedCourse() {
      purchasedCourse().then(res => {
        if (res.state == 1) this.hasBuy = res.content || false;
      })
    },
    handleClick(buttonName) {
        if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
          return window.open('/frontLogin.do', '_self');
        }
        this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': buttonName
        });
        const expandInfo = `${location.origin}${location.pathname}?hasBuy=1`;
        const params = this.hasBuy ? {
          payLagouCoinNum: 699,
          sellGoodsPriceId: 105707,
          expandInfo
          } : {
            payLagouCoinNum: 1,
            sellGoodsPriceId: 105708,
            expandInfo
          }
        lgPay.submitV2(params, {
          payScenesKey: 'kai_wu',
          courseId: 1154
        }).then(() => {

        }).catch(() => {
        });
    },
    handleShowModal() {
      this.eduPlatTrack('WebButtonClick', {
          'page_id': this.page_id,
          'button_name': "获取专属内推服务"
        });
      if (this.isApp) {
        return this.openWeapp();
      }
      this.showModal = true;
    },
    openWeapp() {
      if (!this.isApp) {
        return;
      }
      this.showModal = false;
      window.lgBridge && window.lgBridge.request('check_install', {
        'data': {
            'app_names': ['wechat']
        }
      }, (res) => {
        if (res.data && res.data.data) {
          let { wechat } = res.data.data;
          if (wechat === 0) {
            /**
             * miniProgramType
             *    IOS: 1 小程序正式版  2 开发版  3 体验版
             *    安卓: 0 小程序正式版  1 开发版  2 体验版
             */
            const userName = 'gh_5bc6c955d1db';
            const path = `/pages/card/index.html`;
            const miniProgramType = this.isAndroid ? 0 : 1;
            const locationPath = encodeURIComponent(path);
            if (this.isEduApp) {
              const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
              const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
              const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
              window.location = bridgeUrl;
            } else if (this.isLgApp) {
              const lgBridgeTitle = this.isAndroid ? 'lagouapp' : 'lagou';
              const lgPath = this.isAndroid ? path : locationPath;
              const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
              window.location = lgBridgeUrl;
            }
          } else {
            this.$message.warning('未安装微信');
          }
        }
      });
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 890px;
  overflow-y: auto;
  background-color: #ECF9F5;
  padding-bottom: 235px;
  .img-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    .img-item {
      width: 100%;
    }
  }
  .service-tips {
    width: 560px;
    height: 46px;
    line-height: 46px;
    border-radius: 23px;
    background-color: #fff;
    text-align: center;
    margin: 0 auto;
    font-size: 26px;
    color: #666;
    .service-txt {
      color: #027AE5;
      text-decoration: underline;
    }
  }
}
.bottom-btn {
  position: absolute;
  left: 50%;
  bottom: -47px;
  width: 368px;
  height: 94px;
  transform: translateX(-50%);
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/img/h5/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
.footer-wrap{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 165px;
  background-color: #fff;
  width: 100%;
  .footer-tips{
    width: 100%;
    font-size: 24px;
    text-align: center;
    color: #666666;
    margin-top: 16px;
  }
  .service{
    color: #0174DA;
  }
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .footer-wrap{
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom:env(safe-area-inset-bottom);
  }
}
.footer {
  display: flex;
  flex: 1;
  width: 100%;
  padding: 0 25px 0 37px;
  height: 100%;
  box-sizing: border-box;
  // align-items: center;
  justify-content: space-between;
  .footer-left {
    height: 165px;
    .price {
      margin-top: 4px;
      font-size: 80px;
      color: #ff5151;
      .symbol {
        font-size: 56px;
      }
      .cut {
        font-size: 25px;
        text-decoration: line-through;
      }
    }
    .price-tips {
      font-size: 26px;
      color: #666;
      text-indent: 8px;
      margin-top: -20px;
    }
  }
  .footer-right {
    position: relative;
    display: flex;
    width: 372px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(180deg, #ffa351 0%, #ff4000 100%);
    border-radius: 6px;
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    align-items: center;
    text-align: center;
    padding-left: 20px;
    box-sizing: border-box;
    margin-top: 42px;
    .footer-img {
      width: 12px;
      height: 30px;
      margin-left: 12px;
    }
    .right-tips {
      position: absolute;
      top: -64px;
      right: 54px;
      height: 42px;
      line-height: 42px;
      background-color: #FF5B5B;
      padding: 0 8px;
      border-radius: 4px;
      font-weight: normal;
      font-size: 22px;
      &::after {
        position: absolute;
        bottom: -12px;
        right: 10px;
        display: inline-block;
        content: "";
        border-top: 6px solid #ff5b5b;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #ff5b5b;
        z-index: -1;
      }
    }
    .img-btns {
      position: absolute;
      top: -10px;
      left: 0px;
      animation: left 1.5s infinite linear;
      width: 180px;
      height: 100px;
    }
    @keyframes left {
      0% {
        left: -10%;
      }
      50% {
        left: 100%;
      }
      100% {
        left: 200%;
      }
    }
  }
}
.swiper-content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding: 50px 0;

  .show-swiper {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .swiper-slide {
      width: 500px;
      // 表示所有属性都有动作效果，过度时间为0.4s，以慢速开始和结束的过渡效果
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

      .swiper-item {
        width: 100%;
        height: 500px;
        background: rgb(140, 172, 134);
        border-radius: 6px;
        color: orangered;
        font-size: 24px;
        line-height: 1.5;
        border: 1px solid orangered;
      }
    }
  }
}
.footer-oth {
  display: flex;
  flex: 1;
  width: 100%;
  height: 165px;
  padding: 14px 40px;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  .footer-oth-left {
    width: 420px;
    height: 82px;
    line-height: 82px;
    background: #F2FBF9;
    border-radius: 4px;
    border: 1px solid #00B38A;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FF7536;
    text-align: center;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #FFA182;
  }
  .footer-oth-right {
    width: 230px;
    height: 87px;
    line-height: 82px;
    // background: #00B38A;
    background: linear-gradient(180deg, #FFA351 0%, #FF4000 100%);
    border-radius: 4px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .footer-tips{
    padding-bottom:constant(safe-area-inset-bottom);
    padding-bottom:env(safe-area-inset-bottom);
  }
}
 .sw-box {
    width: 100%;
    height: 296px;
    margin: 44px 0 9px;
    /deep/ .sw-container {
      width: 100%;
      height: 296px;
    }
    /deep/ .swiper-slide-shadow-left, /deep/ .swiper-slide-shadow-right {
        background: rgba(198, 206, 238, 0.23);
    }
    .sw-item {
      width: 460px !important;
      height: 296px;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFF0E9 100%);
      box-shadow: 0px 0px 8px 0px rgba(149, 149, 149, 0.41);
      border-radius: 5px;
      // background: url("../assets/img/h5/sw-bottom.png") no-repeat;
      // border: 1px solid #FFFFFF;
      // overflow: hidden;
      .sw-item-header {
        display: flex;
        // width: 520px;
        height: 296px;
        // background-color: #e8f0ff;
        padding: 87px 0px 35px 0px;
        box-sizing: border-box;
        .sw-item-img {
          width: 114px;
          height: 114px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          .sw-img {
            width: 114px;
            height: 114px;
            border-radius: 50%;
          }
        }
        .sw-info {
          flex: 1;
          .sw-name {
            text-align: center;
            height: 45px;
            font-size: 34px;
            font-weight: bold;
            color: #333;
            line-height: 45px;
          }
          .sw-post {
            height: 40px;
            font-size: 29px;
            color: #fff;
            background: #FF9151;
            border-radius: 16px;
            margin: auto 44px;
            margin-top: 19px;
            text-align: center;
            line-height: 40px;
          }
          .sw-labels {
            width: 100%;
            height: 26px;
            margin-top: 18px;
            .label {
              flex-shrink: 0;
              height: 26px;
              line-height: 26px;
              margin-top:5px;
              padding: 0 10px;
              color: #666666;
              font-size: 26px;
              text-align: center;
              margin-right: 6px;
              border-radius: 13px;
            }
          }
        }
      }
      .sw-con {
        width: 100%;
        height: 97px;
        padding: 21px 0 18px;
        .sw-con-txt {
          font-size: 22px;
          color: #395dc0;
          line-height: 29px;
          text-align: center;
          &.sw-con-txt1 {
              margin: 16px;
          }
        }
      }
    }
    // .sw-item {
    //   transform: scale(0.9);
    // }
    // .swiper-slide-active {
    //   transform: scale(1);
    //   z-index: 9999 !important;
    // }
  }
  .sw-tip{
    color: #787878;
    font-size: 24px;
    text-align: right;
    padding-bottom: 28px;
  }
</style>
